export default "__VITE_ASSET__DBMGNh$i__"